<template lang="html">

  <div v-if="content != null && review_lang != null">
    <div class="d-flex flex-column">
      <div class="d-flex flex-row align-items-center">
        <div class="row g-0 align-self-center align-items-center justify-content-center">
          <div class="cta-3 text-primary">Réponse en cours de validation</div>
        </div>

        <button :class="{'btn-success': hasSentEmail, 'btn-outline-primary': !hasSentEmail}"
                v-if="context.email_action != null"
                type="button"
                class="btn btn-sm btn-icon btn-icon-only ms-1 ms-auto"
                data-bs-toggle="modal"
                :data-bs-target="'#note-modal'+content.uid">
          <i class="bi-app-indicator"></i>
        </button>
        <div class="dropdown is-right"
             :class="{'is-active': show_signature}">
          <div class="dropdown-trigger">
            <button
                v-if="review.establishment.signature_set && review.establishment.signature_set.length > 0"
                id="btnGroupDrop3"
                ref="sigTrigger"
                type="button"
                class="btn btn-outline-primary btn-sm btn-icon btn-icon-only ms-1"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                :disabled="!context.active"
                @click="show_signature = !show_signature">
              S
            </button>
          </div>
          <div class="dropdown-menu" aria-labelledby="btnGroupDrop3">
            <a class="dropdown-item"
               href="#"
               v-for="s in review.establishment.signature_set"
               @click="copysig(s)">
              <b> {{ s.language.code }} - {{ s.title }}</b>
              <span v-html="s.content"/>
            </a>
          </div>
        </div>
        <button v-if="can_delete"
                @click="delete_state()"
                type="button"
                class="btn btn-outline-primary btn-sm btn-icon btn-icon-only ms-1">
          <i class="bi-trash"></i>
        </button>
      </div>

      <div class="text-alternate">{{ human_created_on }}</div>

      <form class="row gx-3 gy-2 align-items-center d-flex align-items-center mb-2 mt-2">
        <label class="label" v-if="review.native_lang.code != 'FR'">
          Réponse en français
        </label>
        <CharCounterTextarea grouped
                             ref="answer_fr"
                             placeholder="Texte de la réponse"
                             v-model="content.data.text_fr"
                             :max="max_chars"
                             :readonly="context.active == false"
                             :rows="8"
                             :input-id="'review_state_answer_writing_textarea_answer_fr_' + $store.state.selected_review_uid">
          <button slot="append"
                  class="btn"
                  :class="isOverLimit ? 'btn-outline-danger' : 'btn-outline-primary'"
                  type="button"
                  id="button-area"
                  @click="saveAnswer()"
                  :disabled="!context.active || content.data.text_fr === '' || isOverLimit">Enregistrer
          </button>
        </CharCounterTextarea>
        <div class="btn-group" v-if="review.native_lang.code !== 'FR'">
          <button
              class="btn btn-outline-primary btn-sm"
              style="margin-left: 0.5em; flex-basis: fit-content;"
              type="button"
              @click="translateWithDeepL('EN-GB')"
              :disabled="!content.data.text_fr || isTranslating"
          >
          <span v-if="isTranslating">
            <span class="spinner-border spinner-border-sm me-1" role="status"></span>
            Traduction...
          </span>
            <span v-else>Traduire en anglais</span>
          </button>
          <button
              class="btn btn-outline-primary btn-sm"
              style="margin-left: 0.5em; flex-basis: fit-content;"
              type="button"
              @click="translateWithDeepL(review.native_lang.code)"
              :disabled="!content.data.text_fr || isTranslating"
          >
          <span v-if="isTranslating">
            <span class="spinner-border spinner-border-sm me-1" role="status"></span>
            Traduction...
          </span>
            <span v-else>Traduire en langue originale</span>
          </button>
          <a
              class="btn btn-outline-primary btn-sm"
              style="margin-left: 0.5em; flex-basis: fit-content;"
              :href="deeple_translate_link"
              target="_blank"
              :disabled="!content.data.text_fr"
          >
            <span>Ouvrir dans deepl</span>
          </a>
        </div>
        <label class="label" v-if="review.native_lang.code != 'FR'">
          Réponse traduite
        </label>
        <CharCounterTextarea v-if="review.native_lang.code != 'FR'"
                             grouped
                             ref="answer_native"
                             placeholder="Texte de la réponse"
                             v-model="content.data.text_native"
                             :max="max_chars"
                             :readonly="context.active == false"
                             :rows="8"
                             :input-id="'review_state_answer_writing_textarea_answer_native_' + $store.state.selected_review_uid">
          <button slot="append"
                  class="btn"
                  :class="isOverLimit ? 'btn-outline-danger' : 'btn-outline-primary'"
                  type="button"
                  id="button-area"
                  @click="saveAnswer()"
                  :disabled="!context.active || content.data.text_native === '' || isOverLimit">Enregistrer
          </button>
        </CharCounterTextarea>
      </form>

      <div v-if="content.data.text_history">
        <h3>Historique ({{ content.data.text_history.length }} Modification(s))</h3>
        <table class="table history-table">
          <tr>
            <td style="font-weight:bold;">Avant</td>
            <td style="font-weight:bold;">Après</td>
          </tr>
          <template v-for="mod in text_history_ordered">
            <tr>
              <td colspan="2" style="font-weight:bold;">
                {{ mod.user.repr }}
                <span :title="mod.date">
                                {{ mod.date|from_now }}
                            </span>
              </td>
            </tr>
            <tr>
              <td>
                <div class="history-cell">{{ mod.before }}</div>
              </td>
              <td>
                <div class="history-cell" v-html="modified(mod.before, mod.after)"></div>
              </td>
            </tr>
          </template>
        </table>
      </div>

      <StateComments :comments="content.data.comments"
                     :active="context.active"
                     v-on:comments:added="update_data"
                     v-on:comments:updated="update_data">
      </StateComments>

    </div>

  </div>
</template>

<script>
import settings from "@/settings";
import tools from "@/tools.js";
import StateComments from "@/components/StateComments.vue";
import CharCounterTextarea from "@/components/ui/CharCounterTextarea.vue";
import REVIEW_LANG from '@/gql/queries/reviewLang.graphql';
import {gqlQuery} from '@/gqlClient.js';
import moment from "moment";
import diff from "diff";

moment.locale("fr");

export default {
  name: "StateAnswerTextValidation",
  components: {StateComments, CharCounterTextarea},
  props: {
    context: {
      type: Object,
      required: true
    },
    can_delete: Boolean,
    email_set: Array,
    review: Object
  },
  data() {
    return {
      content: null,
      review_lang: null,
      nofr: false,
      show_signature: false
    };
  },
  computed: {
    text_history_ordered() {
      let ret = [];
      if (this.context.data.text_history) {
        ret = this.context.data.text_history.sort((a, b) => {
          return new Date(b.date).getTime() - new Date(a.date).getTime();
        });
      }
      return ret;
    },
    deeple_translate_link() {
      let text = "";
      if (this.content && this.content.data.text_fr) {
        text = this.content.data.text_fr.replace(/&/g, " ").replace(/\//g, "∕");
      }
      return "https://www.deepl.com/translator#fr/en-gb/" + encodeURIComponent(text);
    },
    human_created_on() {
      return moment(this.context.created_on).fromNow();
    },
    max_chars() {
      return tools.nbr_char_max(this.review ? this.review.platform : null);
    },
    // Les deux boutons enregistrent l'intégralité de content.data : dès qu'un des
    // deux textes dépasse la limite, aucun des deux ne doit pouvoir enregistrer.
    isOverLimit() {
      if (!this.content || !this.content.data) {
        return false;
      }
      return (
          tools.is_over_limit(this.content.data.text_fr, this.max_chars) ||
          tools.is_over_limit(this.content.data.text_native, this.max_chars)
      );
    },
    hasSentEmail() {
      return this.email_set.length > 0 &&
          this.email_set.some(email => email.sent_on != null && email.sent_on !== "");
    }
  },
  methods: {
    // Le store attend un vrai noeud DOM (highlight_element / focus) : on va
    // chercher le textarea à l'intérieur de CharCounterTextarea.
    textarea_el(ref_name) {
      const wrapper = this.$refs[ref_name];
      return wrapper ? wrapper.$refs.textarea : null;
    },
    async translateWithDeepL(lang) {
      if (!this.content.data.text_fr || this.isTranslating) return;

      this.isTranslating = true;

      try {
        const response = await this.$http.post(
            settings.backendUrl + "/admin/api/translate_deepl",
            {
              text: this.content.data.text_fr,
              target_lang: lang
            },
            {headers: {'Content-Type': 'application/json'}}
        );

        if (!response.ok) {
          throw new Error(`Translation error: ${response.status}`);
        }

        const data = await response.json();
        this.content.data.text_native = data.translations[0].text;

        this.$store.dispatch("notify", {
          level: "success",
          text: "Traduction réussie!",
          seconds: 3
        });
      } catch (error) {
        console.error('Translation error:', error);
        this.$store.dispatch("notify", {
          level: "danger",
          text: "Erreur lors de la traduction",
          seconds: 5
        });
      } finally {
        this.isTranslating = false;
      }
    },
    modified(before, after) {
      if (!before) before = "";
      if (!after) after = "";
      const text_diff = diff.diffWords(before, after);
      let out = "";
      for (const part of text_diff) {
        if (part.added) {
          out += '<span style="background-color:#cefacb;">' + part.value + '</span>';
        } else if (part.removed) {
          out += '<span style="background-color:#facbcb;">' + part.value + '</span>';
        } else {
          out += part.value;
        }
      }
      return out;
    },
    delete_state() {
      this.$emit("state:delete_state");
    },
    update_data(comments) {
      this.content.data.comments = comments;
      this.$emit("state:update_data", this.content.data);
    },
    saveAnswer() {
      this.$emit("state:update_data", this.content.data);
      this.$store.commit("delete_edited_fields", {key: "text_native"});
      this.$store.commit("delete_edited_fields", {key: "text_fr"});
    },
    set_answer_content(value) {
      this.content.data.text_fr = value;
    },
    copysig(signature) {
      if (signature.language.code === "FR") {
        if (this.content.data.text_fr == null) this.content.data.text_fr = "";
        this.content.data.text_fr += "\n\n" + signature.content;
        this.copySignature(signature);
      } else {
        if (this.review_lang.code === "FR") {
          setTimeout(() => {
            this.$store.dispatch("notify", {
              level: "danger",
              text: "Echec de la copie, cet avis est en français",
              seconds: 5
            });
          }, 100);
        } else {
          if (this.content.data.text_native == null) this.content.data.text_native = "";
          this.content.data.text_native += "\n\n" + signature.content;
          this.copySignature(signature);
        }
      }
    },
    copySignature(signature) {
      const text = signature.content;
      const textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.style.top = "0";
      textArea.style.left = "0";
      textArea.style.position = "fixed";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
      this.$store.dispatch("notify", {
        level: "success",
        text: "Copié!",
        seconds: 2
      });
    },
    closeListener(e) {
      if (this.$refs.sigTrigger !== e.target) {
        this.show_signature = false;
      }
    }
  },
  async mounted() {
    this.$root.state_set_answer_content = this.set_answer_content;
    const response = await gqlQuery(REVIEW_LANG, {uid: this.content.uid});
    if (response.ok) {
      this.review_lang = response.body.data.state.review.native_lang;
      this.nofr = this.review_lang.code !== "FR";
    }
    document.addEventListener("click", this.closeListener, true);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.closeListener, true);
  },
  created() {
    this.content = tools.deep_copy(this.context);
    this.$djangows["onmodelsignals"]({modelName: "state", appLabel: "state"}, (event) => {
      if (event.obj) {
        if (event.obj.uid === this.content.uid) {
          if (event.signal_type === "post_save" && event.created === false) {
            this.content.data.comments = event.obj.data.comments;
            this.content.data.text_history = event.obj.data.text_history;
          }
        }
      }
    });
  },
  watch: {
    "content.data.text_native"(newV) {
      if (this.$refs.answer_native) {
        this.$store.commit("update_edited_fields", {
          key: "text_native",
          value: newV,
          verbose_name: "Réponse traduite",
          el: this.textarea_el("answer_native")
        });
      }
    },
    "content.data.text_fr"(newV) {
      if (this.$refs.answer_fr) {
        this.$store.commit("update_edited_fields", {
          key: "text_fr",
          value: newV,
          verbose_name: "Réponse en francais",
          el: this.textarea_el("answer_fr")
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.history-table {
  table-layout: fixed;
  width: 100%;
}

.history-cell {
  white-space: pre-wrap;
  word-break: break-word;
  overflow-wrap: break-word;
  font-family: inherit;
}
